/**
 * 基础常量配置
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */



import {companySource} from "./common";
/**
 *
 * 微信公众号appid
 * 票税助手：xfp
 * 票税助手商户版：xfpmer
 * 第三方公众号用分组代码来标识
 */
export var wechatAppid = {
  xfp: 'wxa162fb6b362c3016',
  xfpmer: 'wxe78e1e22709d38ef',
  capitaland: 'wxbe1075cc0afb331e',
  BGY: 'wx4432d2f1de326d49',
};

/**
 * 抬头类型
 * 企业，个人或政府机构
 */
export var invoiceTitleType = {
  /**企业 */
  company: 1,
  /**个人、政府机构 */
  person: 0,
  /**非企业性单位 */
  nonbusiness: 2,
};

/**
 * 发票种类
 * 普通发票、电子普通发票、专用发票
 */
export var invoiceType = {
  /**普通发票 */
  puTong: 'c',
  /**电子普通发票 */
  dianZiPuTong: 'ce',
  /**专用发票 */
  zhuanYong: 's',
  /**电子专用发票 */
  dianziZhuanYong: 'se',
};

/**
 * 德邦发票报销类型
 * 个人、BP岗
 */
export const depponReimBurseType = {
  /**个人 */
  personal: 'personal',
  /**BP */
  BP: 'BP',
};

/**
 * 影像文档类型
 * -1未定义；1、增值税发票；2、火车票；3、出租车票；
 * 4、飞机票；5、通讯发票；6、定额发票；
 * 7、结算单；8、业务单；99、其他
 */
export var documentType = {
  /**未定义 */
  unDefined: -1,
  /**增值税发票 */
  zengZhiShui: 1,
  /**火车票 */
  huoChe: 2,
  /** 出租车票*/
  chuZuChe: 3,
  /**飞机票 */
  feiJi: 4,
  /**通讯发票 */
  tongXun: 5,
  /**定额发票 */
  dingE: 6,
  /**结算单 */
  jieSuanDan: 7,
  /**业务单 */
  yeWuDan: 8,
  /**其他 */
  other: 99,
};

/**
 * 所有发票文档分类  包含大小类
 */
export var documentTypeAllList = [
  {
    name: '增值税专用发票',
    value: '1000',
    children: [
      {
        name: '增值税专用发票',
        value: '10001001',
      },
      {
        name: '增值税电子专用发票',
        value: '10001003',
      },
    ],
  },
  {
    name: '增值税普通发票',
    value: '2000',
    children: [
      {
        name: '增值税普通发票',
        value: '20001001',
      },
      {
        name: '增值税普通发票(农产品)',
        value: '20001002',
      },
    ],
  },
  {
    name: '增值税电子普通发票',
    value: '3000',
    children: [
      {
        name: '增值税电子普通发票',
        value: '30001001',
      },
    ],
  },
  {
    name: '增值税普通发票(卷票)',
    value: '4000',
    children: [
      {
        name: '增值税普通发票(卷票)',
        value: '40001001',
      },
    ],
  },
  {
    name: '普通发票',
    value: '5000',
    children: [
      {
        name: '机动车销售统一发票',
        value: '50001001',
      },
      {
        name: '飞机票',
        value: '50001009',
      },
      {
        name: '火车票',
        value: '50001010',
      },
      {
        name: '出租车票',
        value: '50001011',
      },
      {
        name: '通讯发票',
        value: '50001012',
      },
      {
        name: '地方通用机打发票',
        value: '50001002',
      },
      {
        name: '地方通用电子发票',
        value: '50001018',
      },
      {
        name: '运输业统一发票',
        value: '50001003',
      },
      {
        name: '废旧物资发票',
        value: '50001004',
      },
      {
        name: '农产品收购发票',
        value: '50001005',
      },
      {
        name: '农产品销售发票',
        value: '50001006',
      },
      {
        name: '营业税发票',
        value: '50001007',
      },
      {
        name: '境外发票',
        value: '50001008',
      },
      {
        name: '定额发票',
        value: '50001013',
      },
      {
        name: '其他发票',
        value: '50009999',
      },
    ],
  },
  {
    name: '非发票文档',
    value: '9000',
    children: [
      {
        name: '政府行政事业单位通用收据',
        value: '90001001',
      },
      {
        name: '银行收款凭证',
        value: '90001002',
      },
      {
        name: '税收通用缴款书',
        value: '90001003',
      },
      {
        name: '税收完税证明',
        value: '90001004',
      },
      {
        name: '海关进口增值税专用缴款书',
        value: '90001005',
      },
      {
        name: '结算单',
        value: '90001006',
      },
      {
        name: '其他影像文档',
        value: '90009999',
      },
    ],
  },
];

export var documentTypeAllListData = [
  {
    name: '增值税发票',
    value: 'vatInvoice',
    parent: 0,
    status:['HISUN']
  },
  {
    name: '全电发票',
    value: 'qInvoice',
    parent: 0,
    // status:['HISUN']
  },
  {
    name: '非增值税发票',
    value: 'nonVatInvoice',
    parent: 0,
    status:['HISUN']
  },
  {
    name: '非发票票据',
    value: 'nonInvoice',
    parent: 0,
  },
  {
    name: '附件',
    value: 'appendecies',
    parent: 0,
    status:['HISUN'],
    private: true,
  },
  {
    name: '电子发票（普通发票）',
    value: '30001004',
    parent: 'qInvoice',
    // status:['HISUN']
  },
  {
    name: '电子发票（增值税专用发票）',
    value: '10001004',
    parent: 'qInvoice',
    // status:['HISUN']
  },

  {
    name: '增值税专用发票',
    value: '10001001',
    parent: 'vatInvoice',
    status:['HISUN']
  },
  {
    name: '增值税电子专用发票',
    value: '10001003',
    parent: 'vatInvoice',
  },
  // {
  //   name: '增值税专用发票(抵扣联)',
  //   value: '10001002',
  //   parent: 'vatInvoice',
  //   status:['HISUN']
  // },
  {
    name: '增值税专用发票(抵扣联)',
    value: '10001002',
    parent: 'vatInvoice',
    status:['HISUN']
  },
  {
    name: '增值税普通发票',
    value: '20001001',
    parent: 'vatInvoice',
    status:['HISUN']
  },
  {
    name: '增值税普通发票(农产品)',
    value: '20001002',
    parent: 'vatInvoice',
    status:['HISUN']
  },
  {
    name: '增值税电子普通发票',
    value: '30001001',
    parent: 'vatInvoice',
    status:['HISUN']
  },
  {
    name: '增值税电子普通发票(通行费)',
    value: '30001002',
    parent: 'vatInvoice',
    status:['HISUN']
  },
  {
    name: '增值税普通发票(卷票)',
    value: '40001001',
    parent: 'vatInvoice',
    status:['HISUN']
  },
  {
    name: '机动车销售统一发票',
    value: '50001001',
    parent: 'nonVatInvoice',
  },
  {
    name: '行程单',
    value: '50001009',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '火车票',
    value: '50001010',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '过路费',
    value : '50001014',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '出租车票',
    value: '50001011',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '区块链电子普通发票',
    value: '50001017',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '客运汽车',
    value: '50001016',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '通讯发票',
    value: '50001012',
    parent: 'nonVatInvoice',
  },
  {
    name: '地方通用机打发票',
    value: '50001002',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '地方通用电子发票',
    value: '50001018',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '运输业统一发票',
    value: '50001003',
    parent: 'nonVatInvoice',
  },
  {
    name: '废旧物资发票',
    value: '50001004',
    parent: 'nonVatInvoice',
  },
  {
    name: '农产品收购发票',
    value: '50001005',
    parent: 'nonVatInvoice',
  },
  {
    name: '农产品销售发票',
    value: '50001006',
    parent: 'nonVatInvoice',
  },
  {
    name: '营业税发票',
    value: '50001007',
    parent: 'nonVatInvoice',
  },
  {
    name: '境外发票',
    value: '50001008',
    parent: 'nonVatInvoice',
  },
  {
    name: '定额发票',
    value: '50001013',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '其他发票',
    value: '50009999',
    parent: 'nonVatInvoice',
    status:['HISUN']
  },
  {
    name: '政府行政事业单位通用收据',
    value: '90001001',
    parent: 'nonInvoice',
  },
  {
    name: '银行收款凭证',
    value: '90001002',
    parent: 'nonInvoice',
  },
  {
    name: '税收通用缴款书',
    value: '90001003',
    parent: 'nonInvoice',
  },
  {
    name: '税收完税证明',
    value: '90001004',
    parent: 'nonInvoice',
  },
  {
    name: '海关进口增值税专用缴款书',
    value: '90001005',
    parent: 'nonInvoice',
  },
  {
    name: '结算单',
    value: '90001006',
    parent: 'nonInvoice',
  },
  {
    name: '附件',
    value: '90009999',
    parent: 'nonInvoice',
    status:['HISUN']
  },
  {
    name: '附件',
    value: '90009999',
    parent: 'appendecies',
    status:['HISUN'],
    private: true,
  },
  // {
  //   name: '其他附件',
  //   value: '90009999',
  //   parent: 'appendecies',
  //   status:['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '餐饮结账单',
  //   value: 'FB_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '住宿水单',
  //   value: 'SB_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '场租水单',
  //   value: 'WB_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '刷卡单',
  //   value: 'SWB_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '携程机票邮件',
  //   value: 'TE_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '书面审批材料',
  //   value: 'WAE_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '日程（如会议日程、培训日程、培训通知函等）',
  //   value: 'SC_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '内部礼品签收单',
  //   value: 'GS_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '行程明细 ',
  //   value: 'SD_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // },
  // {
  //   name: '其他（如销货清单、物品明细、运单明细等）',
  //   value: 'OT_90009999',
  //   parent: 'appendecies',
  //   status: ['HISUN'],
  //   private: true,
  // }
];



/**
 * 票种 大分类
 *
 * 6大类
 */
export var documentTypeLevel1 = {
  /**增值税专用发票 */
  zengZhiShuiZhuanYong: 1000,
  /**增值税普通发票 */
  zengZhiShuiPuTong: 2000,
  /** 增值税电子普通发票*/
  zengZhiShuiDianZiPuTong: 3000,
  /**增值税普通发票(卷票) */
  zengZhiShuiPuTongJuan: 4000,
  /**普通发票 */
  puTong: 5000,
  /**非发票 */
  feiFaPiao: 9000,
};

/**
 * 影像文档类型
 */
export var documentTypeArray = [
  /**增值税发票 */
  {
    name: '所有分类',
    value: '',
  },
  /**增值税专用发票 */
  {
    name: '增值税专用发票',
    value: 10001001,
  },
  /**增值税电子专用发票 */
  {
    name: '增值税电子专用发票',
    value: 10001003,
  },
  /**增值税专用发票 */
  {
    name: '增值税专用发票(抵扣联)',
    value: 10001002,
  },
  /**增值税普通发票 */
  {
    name: '增值税普通发票',
    value: 20001001,
  },
  /** 增值税电子普通发票*/
  {
    name: '增值税电子普通发票',
    value: 30001001,
  },
  /** 增值税电子普通发票(通行费)*/
  {
    name: '增值税电子普通发票(通行费)',
    value: 30001002,
  },
  {
    name: '区块链电子普通发票',
    value: 50001017,
  },
  /**增值税普通发票(卷票) */
  {
    name: '增值税普通发票(卷票)',
    value: 40001001,
  },
  /**普通发票 */
  {
    name: '普通发票',
    value: 5000,
  },
  /**火车票 */
  {
    name: '火车票',
    value: 50001010,
  },
  /**飞机票 */
  {
    name: '飞机票',
    value: 50001009,
  },
  /**出租车票 */
  {
    name: '出租车票',
    value: 50001011,
  } /**通讯发票 */,
  {
    name: '通讯发票',
    value: 50001012,
  },
  {
    name: '客运汽车',
    value: '50001016',
  },
  {
    name: '过路费',
    value: '50001014',
  },
  /**非发票 */
  {
    name: '其他非发票文档',
    value: 9000,
  },
];

/**
 * 销项发票类型
 */
export var invoiceTypeArray = [
  {
    name: '所有分类',
    value: '',
  },
  /** 增值税电子普通发票*/
  {
    name: '增值税电子普通发票',
    value: 'ce',
  },
  /**增值税普通发票 */
  {
    name: '增值税普通发票',
    value: 'c',
  },
  /**增值税专用发票 */
  {
    name: '增值税专用发票',
    value: 's',
  },
  /**增值税普通发票(卷票) */
  {
    name: '增值税普通发票(卷票)',
    value: 'ju',
  },
  /**机动车发票 */
  {
    name: '机动车发票',
    value: 'v',
  },
];

/**
 * 商户微信获取授权页方式
 * 0-表示开票前拉取授权页，1-表示开票时，2-表示开票成功后拉取授权页，3-一次授权多次插卡
 */
export var wxAuthUrlConf = {
  /**开票前 */
  beforeInvoice: '0',
  /** 开票时*/
  invoicing: '1',
  /**开票成功后 */
  invoiced: '2',
  /**一次授权多次插卡包 */
  oneAuthCards: '3',
};

/**
 * 发票类别
 * 餐饮、通讯、交通、其他
 */
export var invoiceCategory = {
  /**餐饮 */
  canYin: 1,
  /** 通讯*/
  tongXun: 2,
  /**交通 */
  jiaoTong: 3,
  /**其他 */
  others: 99,
};

/**
 * 发票验真状态
 */
export var invoiceCheckStatus = {
  /**未验真 */
  notCheck: -1,
  /**验真中*/
  checking: 0,
  /**验真成功 */
  checkSuccess: 1,
  /**验真失败 */
  checkFailed: 2,
};
/**
 * 发票抽取状态
 */
export var invoiceExtractStatus = {
  /**未抽取 */
  notExtract: 0,
  /**已抽取 */
  ExtractSuccess: 1,
};

/**
 * 发票报销状态
 */
export var invoiceReimbursementStatus = {
  /**未报销 */
  notReimbursement: '-1',
  /**报销中 */
  reimbursementing: '0',
  /**已报销*/
  reimbursement: '1',
  /**已退回*/
  returned: '2',
};

/**
 * 发票验重状态
 */
export var invoiceUsedStatus = {
  /**已被他人保存 */
  notUniqueFlag: 0,
  /**第一个保存此发票的人，验重状态为1*/
  uniqueFlag: 1,
};

/**
 * 抬头维护状态
 */
export var invoiceHasTitle = {
  /**抬头未维护 */
  notHasTitle: 0,
  /**抬头已维护*/
  hasTitle: 1,
};

/**
 * 发票作废状态
 */
export var invoiceFlag = {
  /**已作废 */
  invalid: 0,
  /**未作废*/
  noInvalid: 1,
};

/**
 * 发票红冲状态
 */
export var redFlag = {
  /**未红冲 */
  noRed: 0,
  /**已红冲*/
  red: 1,
};

/**
 * 销项发票开具状态
 */
export var invoiceStatus = {
  /**已被他人保存 */
  unfinished: 0,
  /**第一个保存此发票的人，验重状态为1*/
  finished: 1,
};

/**
 * 发票识别状态
 */
export var discernStatus = {
  /**待识别 */
  notDiscern: -1,
  /**识别中 */
  discerning: 0,
  /**识别成功(完成)*/
  discernSuccess: 1,
  /**识别失败*/
  discernFailed: 2,
};

/**
 * 分组代码
 */
export var tenantCode = {
  /**神华 */
  shenhua: 'shenhua',
};

/**
 * 发票状态
 */
export var invoiceStatusArray = [
  /**全部状态 */
  {
    name: '全部状态',
    value: '-1',
  },
  {
    name: '未验真',
    value: 'discern_-1',
  },
  {
    name: '验真中',
    value: 'discern_0',
  },
  {
    name: '验真成功',
    value: 'discern_1',
  },
  {
    name: '验真失败',
    value: 'discern_2',
  },
  {
    name: '未报销',
    value: 'reimbursement_-1',
  },
  {
    name: '报销中',
    value: 'reimbursement_0',
  },
  {
    name: '已报销',
    value: 'reimbursement_1',
  },
  {
    name: '已退回',
    value: 'reimbursement_2',
  },
  {
    name: companySource() == 'futureland' ? '已采集' : '已占用',
    value: 'uniqueFlag_0',
  },
  {
    name: '已作废',
    value: 'invoiceFlag_0',
  },
];

/**
 * 销项发票状态
 */
export var sellerInvoiceStatusArray = [
  /**全部状态 */
  {
    name: '全部状态',
    value: '',
  },
  {
    name: '开具中',
    value: '-1',
  },
  {
    name: '已完成',
    value: '1',
  },
];

/**路由名称 */
export var routerNames = {
  //首页
  HomeIndex: 'HomeIndex',

  //扫码登录  微信扫描PC登录页面的二维码，后跳转的页面
  LoginWxbridge: 'LoginWxbridge',
  //扫码登录  微信扫描PC登录页面的二维码，后跳转的页面
  LoginScan: 'LoginScan',
  //统一登录中转
  //所有需要登录的界面，如果没有登录，则都会跳转到此路由
  //执行登录后，在跳回原路由
  LoginIndex: 'LoginIndex',

  //发票抬头 首页、列表、模糊检索
  InvoiceTitleIndex: 'InvoiceTitleIndex',
  //发票抬头 新增
  InvoiceTitleCreate: 'InvoiceTitleCreate',
  //发票抬头 编辑
  InvoiceTitleUpdate: 'InvoiceTitleUpdate',
  //发票抬头 详情
  InvoiceTitleDetail: 'InvoiceTitleDetail',
  OrderInvoiceFollowPrint: 'OrderInvoiceFollowPrint',

  //发票 首页、列表、模糊检索
  InvoiceIndex: 'InvoiceIndex',
  InvoiceV2Index: 'InvoiceV2Index',
  //发票查验  扫描、手工输入、拍照上传
  InvoiceCheck: 'InvoiceCheck',
  //发票 新增  手工录入
  InvoiceCreate: 'InvoiceCreate',
  InvoiceAuthorization: 'InvoiceAuthorization',
  //发票 新增  手工录入  卷票 --扫码后跳转的界面
  // （卷票二维码只有发票代码和发票号码，需要跳转到此界面补充信息）
  InvoiceCreateJuan: 'InvoiceCreateJuan',
  //发票 编辑
  InvoiceUpdate: 'InvoiceUpdate',
  //发票明细 编辑
  InvoiceItemUpdate: 'InvoiceItemUpdate',
  //发票明细 新增
  InvoiceItemCreate: 'InvoiceItemCreate',
  //发票 标签
  InvoiceTag: 'InvoiceTag',
  //选择发票类型
  selectReceipt: 'selectReceipt',
  //发票 详情
  InvoiceDetail: 'InvoiceDetail',

  //发票备注  编辑
  InvoiceUpdateNote: 'InvoiceUpdateNote',

  //发票 图片查看器
  InvoicePhotoViewer: 'InvoicePhotoViewer',
  //发票原件
  //直接location.href跳转  打开图片页面，借助微信浏览器放大缩小功能来查看图片

  //标签管理
  TagManage: 'TagManage',

  //发票分享到邮箱
  InvoiceShare2Email: 'InvoiceShare2Email',

  //个人中心 主页
  PersonalCenterIndex: 'PersonalCenterIndex',
  // 个人中心 用户绑定
  BindUserInfo: 'BindUserInfo',
  //个人中心 绑定手机号(首次)
  PersonalCenterBindMobile: 'PersonalCenterBindMobile',
  //个人中心 绑定手机号(重新绑定)
  PersonalCenterRebindMobile: 'PersonalCenterRebindMobile',
  //个人中心 绑定邮箱
  PersonalCenterBindEmail: 'PersonalCenterBindEmail',
  //个人中心 所属集团信息
  PersonalCenterBindGroup: 'PersonalCenterBindGroup',
  //个人中心 帮助
  PersonalCenterHelp: 'PersonalCenterHelp',

  //关于我们
  AboutUs: 'AboutUs',

  //帮助中心 主页
  HelpCenterIndex: 'HelpCenterIndex',
  //帮助中心 详情
  HelpCenterDetail: 'HelpCenterDetail',
  //二维码中间页
  OrderInvoiceFollow: 'OrderInvoiceFollow',
  //二维码中间页-微信跳转链接
  OrderInvoiceFollowQrcode: 'OrderInvoiceFollowQrcode',
  //二维码中间页-不需要关注公众号跳转链接
  OrderInvoiceFollowNon: 'OrderInvoiceFollowNon',
  OrderInvoiceFollowPrintinvoice: 'OrderInvoiceFollowPrintinvoice',
  //订单开票 确认页面
  OrderInvoiceConfirm: 'OrderInvoiceConfirm',
  //开票总页面，可进入订单开票和查询发票列表页面
  OrderInvoiceKFP: 'OrderInvoiceKFP',
  //订单填写---通用
  OrderInvoiceFillinOrder: 'OrderInvoiceFillinOrder',
  //订单填写页面
  OrderInvoiceCheckOrder: 'OrderInvoiceCheckOrder',
  //订单开票成功 页面
  OrderInvoiceSuccess: 'OrderInvoiceSuccess',
  //订单开票成功 收到票据微信推送  点击后 打开票据详情界面
  OrderInvoiceDetail: 'OrderInvoiceDetail',
  OrderInvoiceDetailDeprecated: 'OrderInvoiceDetailDeprecated',
  QdInvoiceDetail: 'QdInvoiceDetail',
  //发票占用页面
  InvoiceOccupy: 'InvoiceOccupy',
  //订单开票状态页面
  OrderInvoiceState: 'OrderInvoiceState',
  //集成发票列表页面
  OrderInvoices: 'OrderInvoices',
  //集成发票详情页
  OrderInvoicesOwtDetail: 'OrderInvoicesOwtDetail',

  //订单开票  中间跳转页
  OrderInvoiceIndex: 'OrderInvoiceIndex',
  //订单开票  发票列表
  OrderInvoiceList: 'OrderInvoiceList',
  OrderInvoicePrintList: 'OrderInvoicePrintList',
  //抬头上传
  InvoiceTitleUpload: 'InvoiceTitleUpload',
  //抬头上传成功
  InvoiceTitleUploadSuccess: 'InvoiceTitleUploadSuccess',

  //扫码开票
  //TODO...

  // NoPower: 'NoPower',
  Redirect: 'Redirect',
  Error404: '404',
  // NullPage: 'NullPage',
  // ComingSoon: 'ComingSoon'
};

export var checkObjectType = {
  50001010:'trainTicket',
  50001011:'taxiTicket',
  50001013:'quotaInvoice',
  50001002:'addTax',
  50001018:'addTax',
  50001001:'motorVehicleInvoice',
  50001016:'passengerTicket',
  50001017:'addTax',
  50001009:'travelItinerary',
  50001014:'roadTicket',
  10001001:'addTax',
  20001001:'addTax',
  20001002:'addTax',
  30001001:'addTax',
  30001002:'addTax',
  40001001:'addTax',
  90009999:'other',
  50009999:'other'
}

export const SignFlag = {
  NOT_SIGN: "-1",
  SIGNING: "0",
  SIGN_SUCCESS: "1",
  SIGN_FAIL: "2"
}

export const SignFlagCN = {
  "-1": "无法验签",
  "0": "验签中",
  "1": "验签成功",
  "2": "验签失败"
}

export const iconArr = [
  {name: '火车票',isDiscern:20,documentType:50001010,className:'ditie'},
  {name: '出租车票',isDiscern:30,documentType:50001011,className:'jichengche'},
  {name: '行程单',isDiscern:40,documentType:"50001009xxx",className:'feiji'},
  {name: '定额发票',isDiscern:50,documentType:50001013,className:'fapiao'},
  {name: '机动车发票',isDiscern:60,documentType:50001001,className:'qichezhan'},
  {name: '客运汽车',isDiscern:70,documentType:50001016,className:'qichepiao'},
  {name: '结算单封面',isDiscern:90,documentType:90001006,className:'piaojuguanli'}
]

export const extractFlagStatus = {
  NotSynchronized: '0',
  Synchronized: '1'
}

export const extractFlagStatusCN = {
  '0': '未同步业务系统',
  '1': '已同步业务系统',
}
